<template>
  <v-expansion-panels focusable v-model="panel">
    <scroll-list :items="ids" :pageSize="20">
      <template v-slot:list-item="{ item: id }">
        <individual-list-item
          :id="id"
          :highlights="highlights"
        ></individual-list-item>
      </template>
    </scroll-list>
  </v-expansion-panels>
</template>

<script>
// TODO Expansion panel should expand even if type is clicked.
// TODO ID should only be shown on wide screens. For narrow show when expanded.

import IndividualListItem from './IndividualListItem.vue'
import ScrollList from '@/components/ScrollList.vue'

export default {
  components: {
    IndividualListItem,
    ScrollList,
  },
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
  },
  data: () => ({
    panel: null,
  }),
  watch: {
    ids: function (newIds) {
      // Close any active expansion panel unless list of ids is down to one individual.
      // this.panel = newIds.length == 1 ? 0 : null
      newIds || true
    },
  },
}
</script>
